// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"b8750a50","707":"7848fa47","937":"520d03f5"}[chunkId] + ".chunk.js";
};